import { ScopedDemands } from "lib/authorization/scoped-demands"

export function registerScopedBoundary(scope, mapPropsToPayload = (v) => v) {
    const Boundary = function ScopedBoundary(props) {
        const { id, payload, children, ...rest } = props

        const base = { id, ...(payload || {}), ...rest }
        const finalPayload = mapPropsToPayload(base)

        return (
            <ScopedDemands scope={scope} id={id} payload={finalPayload}>
                {children}
            </ScopedDemands>
        )
    }
    Boundary.displayName = `ScopedBoundary(${scope})`
    Boundary.scope = scope
    return Boundary
}
